/*
  offer-packages.js — "מארזים והצעות" product block
  ------------------------------------------------------
  Two add-to-cart modes per offer:
    native — offer maps to a variant + quantity of the current product.
             We only write into the theme's existing form inputs and let the
             theme's own addToCart() run untouched.
    multi  — offer maps to several line items. We intercept the ATC click in
             the capture phase and POST /cart/add.js with an items[] array,
             mirroring the theme's own frequently-bought-together flow.
*/
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function store(name) {
    try {
      return window.Alpine && window.Alpine.store ? window.Alpine.store(name) : null;
    } catch (e) {
      return null;
    }
  }

  function OfferPackages(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id') || '';
    this.options = [].slice.call(root.querySelectorAll('[data-ofp-option]'));
    this.errorEl = root.querySelector('[data-ofp-error]');
    this.current = null;
    this.busy = false;
    if (!this.options.length) return;
    this.bind();

    var preselected = null;
    for (var i = 0; i < this.options.length; i++) {
      var input = this.options[i].querySelector('input[type="radio"]');
      if (input && input.checked) { preselected = this.options[i]; break; }
    }
    this.select(preselected || this.options[0]);
  }

  OfferPackages.prototype.bind = function () {
    var self = this;

    this.options.forEach(function (option) {
      var input = option.querySelector('input[type="radio"]');
      if (!input) return;
      input.addEventListener('change', function () {
        if (input.checked) self.select(option);
      });
      // Keyboard support for the card itself.
      option.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          input.checked = true;
          self.select(option);
        }
      });
    });

    if (!this.sectionId) return;

    // Capture phase: runs before Alpine's own @click on the button, so for
    // native offers the form is already correct by the time addToCart reads it,
    // and for multi offers we can cancel the theme handler entirely.
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var btn = target.closest(
        '#x-atc-button-' + self.sectionId + ', #x-atc-button-sticky-' + self.sectionId
      );
      if (!btn || !self.current) return;

      self.applyToForm();

      if (self.current.mode !== 'multi') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      self.addBundle(btn);
    }, true);
  };

  OfferPackages.prototype.select = function (option) {
    var self = this;
    this.options.forEach(function (other) {
      other.classList.toggle('is-selected', other === option);
    });
    var input = option.querySelector('input[type="radio"]');
    if (input) input.checked = true;

    var items = [];
    try {
      items = JSON.parse(option.getAttribute('data-items') || '[]');
    } catch (e) {
      items = [];
    }

    this.current = {
      mode: option.getAttribute('data-mode') || 'native',
      variantId: option.getAttribute('data-variant') || '',
      quantity: parseInt(option.getAttribute('data-qty') || '1', 10) || 1,
      discount: option.getAttribute('data-discount') || '',
      items: items,
      option: option
    };

    this.clearError();
    this.applyToForm();

    document.dispatchEvent(new CustomEvent('ofp:offer-selected', {
      detail: { blockId: self.root.getAttribute('data-block-id'), offer: self.current }
    }));
  };

  // Writes the selected offer into the theme's existing product form inputs.
  OfferPackages.prototype.applyToForm = function () {
    if (!this.current || !this.sectionId) return;
    var sid = this.sectionId;

    if (this.current.variantId) {
      var idInputs = document.querySelectorAll(
        '[id="update-variant-' + sid + '"], [id="update-variant-sticky-' + sid + '"]'
      );
      [].forEach.call(idInputs, function (el) {
        if (el.value !== this.current.variantId) {
          el.value = this.current.variantId;
          el.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }.bind(this));
    }

    var qty = this.current.quantity > 0 ? this.current.quantity : 1;
    var qtyInputs = document.querySelectorAll(
      '[id="Quantity-' + sid + '"], [id="Quantity-atc-' + sid + '"], [id="Quantity-sticky-' + sid + '"]'
    );
    [].forEach.call(qtyInputs, function (el) {
      if (String(el.value) === String(qty)) return;
      el.value = qty;
      // x-model listens on input; change keeps non-Alpine listeners in sync.
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // The sticky bar mirrors quantity through this theme event.
    document.dispatchEvent(new CustomEvent('eurus:product:quantity-changed-' + sid, {
      detail: { quantity: qty }
    }));
  };

  OfferPackages.prototype.showError = function (message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message;
    this.errorEl.classList.remove('ofp-hidden');
  };

  OfferPackages.prototype.clearError = function () {
    if (!this.errorEl) return;
    this.errorEl.textContent = '';
    this.errorEl.classList.add('ofp-hidden');
  };

  OfferPackages.prototype.setLoading = function (btn, state) {
    this.busy = state;
    this.root.classList.toggle('ofp-busy', state);
    if (!btn) return;
    btn.classList.toggle('ofp-btn-loading', state);
    btn.disabled = state;
  };

  OfferPackages.prototype.sectionsToRender = function () {
    var helper = store('xCartHelper');
    if (!helper || typeof helper.getSectionsToRender !== 'function') return [];
    try {
      return helper.getSectionsToRender().map(function (section) { return section.id; });
    } catch (e) {
      return [];
    }
  };

  OfferPackages.prototype.addBundle = function (btn) {
    var self = this;
    if (this.busy || window.updatingCart) return;
    if (!this.current.items.length) return;

    var helper = store('xCartHelper');
    var wait = helper && typeof helper.waitForCartUpdate === 'function'
      ? helper.waitForCartUpdate()
      : Promise.resolve();

    this.setLoading(btn, true);
    this.clearError();

    Promise.resolve(wait).then(function () {
      window.updatingCart = true;
      return fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: self.current.items, sections: self.sectionsToRender() })
      });
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if (response && (response.status === 422 || response.status === '422')) {
        self.showError(response.description || response.message || '');
        return null;
      }
      if (!self.current.discount) return response;
      return self.applyDiscount(self.current.discount).then(function (discountResponse) {
        // The discount call returns a fresher cart render than add.js did.
        if (discountResponse && discountResponse.sections) {
          response.sections = discountResponse.sections;
        }
        return response;
      });
    }).then(function (response) {
      if (!response) return;
      self.renderCart(response);
    }).catch(function (error) {
      console.error('[offer-packages]', error);
      self.showError(self.root.getAttribute('data-error-generic') || '');
    }).finally(function () {
      window.updatingCart = false;
      self.setLoading(btn, false);
    });
  };

  // Same endpoint the theme's own coupon-code.js uses.
  OfferPackages.prototype.applyDiscount = function (code) {
    var self = this;
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code, sections: this.sectionsToRender() })
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      var applied = false;
      if (response && response.discount_codes) {
        response.discount_codes.forEach(function (entry) {
          if (entry.applicable && entry.code.toLowerCase() === code.toLowerCase()) applied = true;
        });
      }
      if (!applied) {
        console.warn('[offer-packages] discount code not applied:', code);
      }
      return response;
    }).catch(function (error) {
      console.error('[offer-packages] discount', error);
      return null;
    });
  };

  OfferPackages.prototype.renderCart = function (response) {
    var helper = store('xCartHelper');
    if (helper && response.sections) helper.reRenderSections(response.sections);

    var quickView = store('xQuickView');
    if (quickView && quickView.show) quickView.show = false;
    var popup = store('xPopup');
    if (popup && typeof popup.close === 'function') popup.close();

    var noti = store('xCartNoti');
    if (noti && noti.enable) {
      noti.setItem(response);
    } else {
      var miniCart = store('xMiniCart');
      if (miniCart && typeof miniCart.openCart === 'function') miniCart.openCart();
      document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));
    }

    var bubble = document.getElementById('cart-icon-bubble');
    if (helper && bubble) helper.currentItemCount = parseInt(bubble.innerHTML, 10);
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-ofp-root]');
    [].forEach.call(roots, function (root) {
      if (root.dataset.ofpReady === 'true') return;
      root.dataset.ofpReady = 'true';
      new OfferPackages(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor re-renders the section on every setting change.
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:block:select', function (event) { init(event.target); });
})();
